// Avoids floating point errors from built in Math.round
function round(num: number, precision = 2): number {
  if (Math.abs(num) < 0.00001) return 0; // avoid issue with exp-notation (1.19e-7)
  // @ts-ignore

  return +(Math.round(num + `e+${precision}`) + `e-${precision}`);
}

const USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

function formatCurrency(
  number: number | undefined | null | string,
  { minimumPrecision = 2, maximumPrecision = 2, hideDollarSign = false } = {},
) {
  if (typeof number === 'string') {
    number = parseFloat(number);
  }
  return `${hideDollarSign ? '' : '$'}${(number ?? 0).toLocaleString('en-US', {
    minimumFractionDigits: minimumPrecision,
    maximumFractionDigits: maximumPrecision,
  })}`;
}

export { round, USDollar, formatCurrency };
